import util from '../../common/util';
import * as TYPES from './_store/types';
import { getStore } from '@/store';
import { getHouseOfficeStatus } from '@/common/mls';

function getListingSort() {
    let firstSort = Array.isArray(this.listingSortOptions)
        ? this.listingSortOptions[0]
        : null;
    return firstSort && firstSort.value;
}

function getFeatureListingName(listingSource) {
    return ['all listings', 'sold listings', 'single property promotion'].indexOf(listingSource.toLowerCase()) !== -1
        ? undefined
        : listingSource.replace(/^\d\+/, '').replace(/\+/g, ' ')
}   

export function setFreshResult(store, result) {
    if (this.count <= 0) {
        store[TYPES.SET_RESULT](null);
        return;
    }
    store[TYPES.SET_RESULT](result);
}

export function freshCenterRequest(store, { url = this.asyncLink } = {}) {
    const { siteId } = getStore.call(this, 'page');
    if (this.count <= 0) {
        store[TYPES.SET_RESULT](null);
        store[TYPES.SET_WAITING](false);
        return;
    }
    let params = {};
    let presetParams = url ? {} : (Object.assign({}, this.presetFiltersV2));
    // let needPrint = store.pageLocation.hostname === 'puckettprop.com';
    // if (needPrint){
    //     store.addLog(`this.asyncLink: ${this.asyncLink}`);
    // }
    if (url) {
        params = util.getQueryField('', url);
        url = url.replace(/\?.+/, '');
        if (params.condition) {
            try {
                const condition = JSON.parse(params.condition);
                presetParams = { ...condition, ...presetParams };
            } catch (err) {
                console.log(err);
            }
        }
    } else {
        url = '/api-site/search/realTimeListings';
    }
    let listingType = '';
    if (!this.listingSource) {
        this.listingSource = '';
    }
    listingType = util.getListingTypeFromListingSource(this.listingSource)
    const listingSort = getListingSort.call(this);
    params = Object.assign(
        params,
        {
            page: 1,
            featureListingName: getFeatureListingName(this.listingSource), 
            listingType: listingType || params.listingType,
            listingSort: listingSort || params.listingSort,
            pageSize: this.count || params.count || 24,
            siteId,
            timeStamp: Date.now(),
            timezone: this.getCookie('timezone') || util.getTimeZone()
        },
        { condition: JSON.stringify(presetParams) }
    );

    // needPrint && store.addLog(`axiosIns send: ${JSON.stringify({ url: url, params: params })}`);
    return this.axiosIns({ url: url, params: params }).then(ret => {
        // needPrint && store.addLog(`${JSON.stringify(ret)}`);
        store[TYPES.SET_WAITING](false);
        // needPrint && store.addLog(`axiosIns callback`);
        ret = ret.data || ret;
        return ret;
    }).then(async(data) => {
        const res = await getHouseOfficeStatus.call(this, data, this.page?.agentCreator?.agentUser?.id);
        return res; 
    }).catch((err) => { 
        console.error('err', err);
    }).finally(() => {
        store[TYPES.SET_WAITING](false);
    });
}

export async function freshCenter(store, { url = this.asyncLink } = {}) {
    const result = await freshCenterRequest.call(this, store, { url });
    setFreshResult.call(this, store, result);
}

export function freshRequest(store, { url = this.asyncLink } = {}) {
    const { siteId } = getStore.call(this, 'page');
    if (this.count <= 0) {
        store[TYPES.SET_RESULT](null);
        store[TYPES.SET_WAITING](false);
        return;
    }
    let params = {};
    let presetParams = {};
    if (!url) {
        presetParams = (this.presetFilters || []).reduce((memo, filter) => {
            if (filter && Array.isArray(filter.values)) {
                memo[filter.dn] = filter.values.join(filter.split || ',');
            }
            return memo;
        }, {});
    }

    if (url) {
        params = util.getQueryField('', url);
        url = url.replace(/\?.+/, '');
    } else {
        url = '/api-site/search/realTimeListings';
    }
    let listingType = '';
    if (!this.listingSource) {
        this.listingSource = '';
    }
    listingType = util.getListingTypeFromListingSource(this.listingSource)
    let key = (presetParams.key && presetParams.key.split(';')) || [];
    delete presetParams.key;
    const listingSort = getListingSort.call(this);
    params = Object.assign(
        params,
        {
            page: 1,
            featureListingName: getFeatureListingName(this.listingSource),                
            listingType: listingType || params.listingType,
            listingSort: listingSort || params.listingSort,
            pageSize: this.count || params.count || 24,
            siteId,
            timeStamp: Date.now(),
            key:
                key
                    .map(k => (k && k.split(':').slice(1).join(':')) || '')
                    .join(';') || params.key,
            keywordType:
                key.map(k => (k && k.split(':')[0]) || 'none').join(';') ||
                params.keywordType,
            timezone: this.getCookie('timezone') || util.getTimeZone()
        },
        presetParams
    );
    
    return this.axiosIns({ url: url, params: params }).then(ret => {
        store[TYPES.SET_WAITING](false);
        ret = ret.data || ret;
        return ret;
    }).then(async(data) => {
        const res = await getHouseOfficeStatus.call(this, data);
        return res; 
    }).catch((err) => {
        console.error('err', err);
    }).finally(() => {
        store[TYPES.SET_WAITING](false);
    });
}

export async function fresh(store, { url = this.asyncLink } = {}) {
    const result = await freshRequest.call(this, store, { url });
    setFreshResult.call(this, store, result);
}

export function asyncData(store) {
    const searchCenter = getStore.call(this, 'page').isSearchCenter;
    if (searchCenter) {
        return freshCenter.call(this, store);
    } else {
        return fresh.call(this, store);
    }
}
